import { ApiResponse } from 'apisauce';
import { OrderInvoice } from '../../../modules/orders/conditions/interfaces/orderInvoices.interface';
import { PaginatedResponse } from '../../../types/request.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import { PaginatedEndpointParams } from '../../types';

export type FindOrderInvoicesParams = PaginatedEndpointParams & {
  orderId: string;
};

export const findOrderInvoices = (
  { orderId, ...params }: FindOrderInvoicesParams,
  signal?: AbortSignal,
): Promise<ApiResponse<PaginatedResponse<OrderInvoice>>> =>
  restApi.get<PaginatedResponse<OrderInvoice>>(`orders/${orderId}/invoices`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });
